import { FC } from 'react';
import { Form } from 'antd';
import TextArea from 'antd/lib/input/TextArea';

type TProps = {
  disabled: boolean;
  setComment: React.Dispatch<React.SetStateAction<string>>;
};

const ModalComment: FC<TProps> = ({ disabled, setComment }) => {
  const handler = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setComment(e.target.value.trim());
  };

  return (
    <Form.Item name="comment" normalize={value => value.replace(/^\s+/g, '')} label="Комментарий">
      <TextArea
        showCount
        rows={4}
        onChange={handler}
        placeholder="Введите текст"
        maxLength={300}
        minLength={1}
        disabled={disabled}
      />
    </Form.Item>
  );
};

export default ModalComment;
